require('./rejectChoreStep.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const InputCharsLeft = require('components/inputCharsLeft/inputCharsLeft');

// @actions
const openYoungCardRejectChoreActions = require('actions/openYoungCardRejectChore');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');

// @constants
const { EURO_TEXT } = require('constants/index');

class RejectChoreStep1 extends React.Component {
    constructor(props){
        super(props);
        this.createList = this.createList.bind(this);
    }

    createList(list) {
        return list.map( (item, key) => {
            if(item.bodyText){
                return (
                    <OKInformativeListItem
                        className={"reject-chores-step__list-item"}
                        key={key}
                        title={item.title}
                        bodyText={item.bodyText}
                        bodyWordBreak={false}
                    />
                )
            }
        });
    }

    render() {
        const { choreDetail, childName, immStep} = this.props;
        const currency = formatCurrency(EURO_TEXT);
        const reward = getFormattedString({ amount: choreDetail.get('reward'), currency });
        const formattedChildName = childName && childName.split(" ").map(str => toFirstUppercase(str)).join(" ");

        const list = [
            {
                title: formatText('openYoungRejectChores-applicant'),
                bodyText: formattedChildName
            },
            {
                title: formatText('openYoungRejectChores-chore'),
                bodyText: formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`)
            },
            {
                title: formatText('openYoungRejectChores-amount'),
                bodyText: reward
            },
            {
                title: formatText('openYoungRejectChores-concept'),
                bodyText: choreDetail.getIn(['comments','choreAssignmentComment'])
            },
            {
                title: formatText('openYoungRejectChores-answer'),
                bodyText: choreDetail.getIn(['comments','childComment'])
            }
        ];
        const remarkValue = immStep.get('remark');
        return (
            <article className="reject-chores-step">
                <section>
                    <h2 className="reject-chores-step__heading">
                        <FormattedText value="openYoungRejectChores-step1Heading" />
                    </h2>
                </section>
                <section className="reject-chores-step__main">
                    <OKInformativeList>
                        {this.createList(list)}
                    </OKInformativeList>
                    <div className="reject-chores-step__reason-input">
                        <InputCharsLeft
                            maxLength="80"
                            label={formatText('openYoungRejectChores-reason')}
                            initialValue={remarkValue}
                            callback={this.props.setRemark}
                        />
                    </div>
                </section>
            </article>
        );
    }
}

RejectChoreStep1.propTypes = {
    childName: PropTypes.string,
    choreDetail: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    setRemark: PropTypes.func,
};
module.exports.RejectChoreStep1 = connect(
    null,
    {
        setRemark: openYoungCardRejectChoreActions.setRemark
    })(RejectChoreStep1);
